import { WorkflowStatusFilterValue } from "@/components/automations/AutomationStatusFilter";
import { ALL_CREATORS_VALUE, type CreatorFilterValue } from "@/components/automations/AutomationCreatorFilter";
import { WorkflowExecutionPhase } from "gitpod-next-api/gitpod/v1/workflow_pb";
import type { WorkflowsFilter } from "@/queries/automation-queries";

export type AutomationFilters = {
    search: string;
    status: WorkflowStatusFilterValue;
    creator: CreatorFilterValue;
};

export const DEFAULT_FILTERS: AutomationFilters = {
    search: "",
    status: WorkflowStatusFilterValue.All,
    creator: ALL_CREATORS_VALUE,
};

export function isFiltered(filters: AutomationFilters): boolean {
    return (
        filters.status !== WorkflowStatusFilterValue.All ||
        filters.creator !== ALL_CREATORS_VALUE ||
        !!filters.search.trim()
    );
}

export function toAPIFilter(filter: AutomationFilters): WorkflowsFilter | undefined {
    const search = filter.search;
    const statusPhases = statusFilterToApiFilter(filter.status);
    const creatorIds = filter.creator !== ALL_CREATORS_VALUE ? [filter.creator] : undefined;

    if (!search && !statusPhases && !creatorIds) {
        return undefined;
    }

    return {
        search: search || undefined,
        statusPhases,
        creatorIds,
    };
}

export function statusFilterToApiFilter(statusFilter: WorkflowStatusFilterValue): WorkflowExecutionPhase[] | undefined {
    switch (statusFilter) {
        case WorkflowStatusFilterValue.Running:
            return [WorkflowExecutionPhase.RUNNING];
        case WorkflowStatusFilterValue.Completed:
            return [WorkflowExecutionPhase.COMPLETED];
        case WorkflowStatusFilterValue.All:
        default:
            return undefined;
    }
}
